import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { cn } from '../../lib/utils';

const WorkflowCreateFolderModal = ({
  isOpen,
  onClose,
  onSubmit,
  initialName = '',
  title = 'Create folder',
  description = 'Organize your workflows into folders.',
  submitting = false,
}) => {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) setName(initialName);
  }, [isOpen, initialName]);

  const handleSubmit = () => {
    if (!name.trim()) return;
    onSubmit?.(name.trim());
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent className="max-w-md bg-zinc-900 border-zinc-700 text-white" data-testid="workflow-create-folder-modal">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="text-zinc-400">{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label htmlFor="folder-name" className="text-zinc-300">Folder name</Label>
          <Input
            id="folder-name"
            data-testid="workflow-folder-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Marketing Workflows"
            className="bg-zinc-800 border-zinc-700 text-white"
          />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" className="border-zinc-700 text-zinc-300" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            data-testid="workflow-create-folder-submit"
            disabled={!name.trim() || submitting}
            className="bg-emerald-600 hover:bg-emerald-700"
            onClick={handleSubmit}
          >
            {submitting ? 'Saving...' : 'Save'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export function WorkflowFolderPermissionsModal({ isOpen, onClose }) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose?.()}>
      <DialogContent className="max-w-md bg-zinc-900 border-zinc-700 text-white">
        <DialogHeader>
          <DialogTitle>Manage permissions</DialogTitle>
          <DialogDescription className="text-zinc-400">
            Folder permissions are coming soon.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default WorkflowCreateFolderModal;
